import { getLanguageFromPath } from "./../../helpers/index.js";
import { toValidLanguage } from "./../../helpers/toValidLanguage.js";
import { useRoute, computed, useRequestEvent } from "#imports";
import {
  languages
} from "#nuxt-language-negotiation/config";
import { useCurrentLanguage as nitroUseCurrentLanguage } from "./../../server/utils/useCurrentLanguage.js";
export function useCurrentLanguage(options) {
  if (import.meta.server) {
    const event = useRequestEvent();
    if (!event) {
      throw new Error("Failed to get request event.");
    }
    const negotiatedLanguage = nitroUseCurrentLanguage(event);
    if (options?.full) {
      return computed(() => {
        return languages.find((v) => v.code === negotiatedLanguage);
      });
    }
    return computed(() => negotiatedLanguage);
  } else {
    const route = useRoute();
    if (options?.full) {
      return computed(() => {
        const language = getLanguageFromPath(route.path);
        const langcode = toValidLanguage(language);
        return languages.find((v) => v.code === langcode);
      });
    }
    return computed(() => {
      return toValidLanguage(getLanguageFromPath(route.path));
    });
  }
}
